import { lazy } from "react";
const Index = lazy(() => import("./pages"));

const routes = [
  {
    name: "Estadísticas de Ventas",
    component: Index,
    exact: true,
    path: "/dashboard/operational-metrics"
  }
];

export default routes;
